<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center py-5 w-100"
  >
    <img
      :src="emptyStateImg"
      :style="{ maxWidth: size + 'px', opacity: 0.5 }"
      alt="Empty State"
    />
    <div class="mt-3 text-muted text-center" :class="fontSizeClass">
      {{ title }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import emptyStateImg from "@/assets/emptyState.png";

const props = defineProps({
  title: {
    type: String,
    default: "No hay información disponible",
  },
  size: {
    type: Number,
    default: 400,
  },
  fontSize: {
    type: String,
    default: "fs-6",
    validator: (value) => /^fs-[1-6]$/.test(value),
  },
});

const fontSizeClass = computed(() => props.fontSize);
</script>
